import { captureMessage } from '@sentry/react';

export interface ActivityIDMMigratorContextInterface {
  captureMessage: typeof captureMessage;
}

export const activityIDMMigratorContext: ActivityIDMMigratorContextInterface = {
  captureMessage,
};
